import { render } from "./FloatingBrandShapesLayout.vue?vue&type=template&id=9b19fd1c"
const script = {}

import exportComponent from "/home/runner/work/uup/uup/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__